<template>
    <PopForm :state="state" width="990px" body-max-height="570px">
        <template v-slot:title>取单</template>
        <div class="search-box">
            <el-input placeholder="请输入单号" v-model="searchValue"
                      @keypress.native="e => {if(e.charCode === 13) setTableData();}">
                <el-button slot="append" type="primary" @click="setTableData()">&nbsp;&nbsp;搜索&nbsp;&nbsp;</el-button>
            </el-input>
        </div>
        <div class="body">
            <el-table :data="tableData" height="400" style="width: 100%" ref="selectTable" class="table-box-1"
                      @select="handleCurrentChange" @select-all="handleSelectAll" @cell-click="selectedRow"
            >
                <el-table-column type="selection" width="55" :selectable="selectIsDisabled"></el-table-column>
                <el-table-column prop="order_no" width="150" label="单号">
                    <template slot-scope="data">
                        {{data.row.order_no ? data.row.order_no : ""}}
                    </template>
                </el-table-column>
                <el-table-column prop="pro_desc" label="项目" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="total_price" width="100" label="总价"></el-table-column>
                <el-table-column prop="create_datetime" width="160" label="挂单时间"></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="data">
                        <el-button type="danger" size="mini" @click.stop="deleteOrder(data.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <template v-slot:foot>
                <div class="foot">
                    <div class="btn-box">
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="selected">确定</el-button>
                    </div>
                </div>
        </template>
    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import PopListSelect from "@/model/PopListSelect";
    import PopForm from "@/model/PopForm";
    export default {
        name: "TempOrder",
        components: {PopForm, PopListSelect},
        model: {
            prop: "state",
            event: "show",
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            listData: {
                type: Array,
                default: () => ([])
            }
        },
        data: () => ({
            originData: [],
            tableData: [],
            searchValue: "",
            page: {
                nowPage: 1,
                pageSize: 500,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },

            selectedListData: [],
        }),
        mounted: function () {

        },
        methods: {
            //设置排除ID
            selectIsDisabled: function (row, index) {
                let tmpId = row.tmp_id;
                for (let key in this.listData){
                    if(tmpId === this.listData[key].tmp_id){
                        return false;
                    }
                }
                return true;
            },
            //数据赋值
            setTableData: function () {
                let tableData = [];
                this.originData.forEach( (item, key) => {
                    if(this.searchValue === "" || item.order_no.indexOf(this.searchValue) > -1){
                        tableData.push(item);
                    }
                });
                this.tableData = tableData;

                obj.unScrollbar(".temp-order-list .el-table__body-wrapper");
                this.$nextTick( () => {
                    obj.scrollbar(".temp-order-list .el-table__body-wrapper");
                });
            },
            //加载数据列表
            loadListData: function () {
                let postData = {
                    page: this.page.nowPage,
                    num: this.page.pageSize,
                    // order_no: this.searchValue ? this.searchValue : "",
                };
                obj.postData("tmp_order/get_tmp_order_list", postData, res => {
                    if(res.errcode === 0){
                        let tableData = [];
                        res.data.list_data.forEach((val, key) => {
                            let proDesc = [];
                            let totalPrice = 0;
                            val.pro_data.forEach(v => {
                                proDesc.push(v.pro_name);
                                totalPrice += v.total_price;
                            });

                            val.pro_desc = proDesc.join("、");
                            val.total_price = "¥" + totalPrice.toFixed(2);

                            tableData.push(val);
                        });

                        this.originData = tableData;
                        this.setTableData();
                        this.page.count = res.data.count;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //关闭
            close: function () {
                this.selectedListData = [];
                this.$emit("show", false);
            },
            //确定选择
            selected: function () {
                this.$emit("selected", this.selectedListData);
                this.close();
            },

            //全选状态改变
            handleSelectAll: function (item) {
                this.selectedListData = item;
            },
            //选中状态改变
            handleCurrentChange: function (item) {
                this.selectedListData = item;
            },
            //点击表格行
            selectedRow: function (data, b) {
                if(this.selectIsDisabled(data))
                    this.$refs.selectTable.toggleRowSelection(data);
            },

            //删除挂单
            deleteOrder: function (data) {
                obj.postData("tmp_order/delete_tmp_order", {tmp_id: data.tmp_id}, res => {
                    if(res.errcode === 0) {
                        obj.message.success("删除成功");
                        this.selectedListData = [];
                        this.loadListData();
                    }else
                        obj.message.error("删除失败");
                });
            }
        },
        watch: {
            state: function (data) {
                if(data)
                    this.loadListData();
            }
        }
    }
</script>

<style scoped>
    .search-box{
        padding: 6px 6px 0;
    }
    .search-box .el-input-group{
        width: 380px;
    }
    .body{
        padding: 16px 6px 0;
        height: 402px;
        overflow: auto;
    }
    .body .el-table, .body .el-table:before{
        background-color: transparent;
        border: none;
    }
    .btn-box{
        padding: 0 20px 10px;
        text-align: right;
    }
</style>
